// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"pop-over-list_popoverContainer__l2I4S","content":"pop-over-list_content__3FTMU","icon":"pop-over-list_icon__1zOB-"};